import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from '../../images/logo.svg';
import { instituteRegistration } from '../../apis/AuthenticationAPI';
import Cookies from "universal-cookie";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const cookies = new Cookies();
const InstituteRegisteration = () => {
   toast.configure();
   const token = cookies.get("token")
   const history = useHistory();
   const handleBlur = (e) => {
      const newInstituteData = { ...instituteData };
      newInstituteData[e.target.name] = e.target.value;
      setInstituteData(newInstituteData);
   };
   useEffect(() => {
		if(token === null || token === undefined )
		{
			history.push("/page-login");
      }		
	}, [])
   const [instituteName, setInstituteName] = useState("");
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [username, setUsername] = useState("");
   const [cpassword, setCPassword] = useState("");
   const [address, setAddress] = useState("");
   const [city, setCity] = useState("");
   const [state, setState] = useState("");
   const [country, setCountry] = useState("");
   const [description, setDescription] = useState("");
   const [contact, setContact] = useState("");
   const [credits, setCredits] = useState("");
   const [avatar,setAvatar] = useState("");
   const [instituteData, setInstituteData] = useState({});
   const submitHandler = (e) => {
      e.preventDefault();
      if(password === cpassword)
      {
         // console.log(avatar);
      instituteRegistration(token,instituteName,username,email,password,address,city,state,country,description,contact,credits)
      .then(response => {
         toast.success("Institute Created", {
            position: 'top-left',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false
          })

        })
        .catch(err => {
          toast.error("Error while updating template.", {
            position: 'top-left',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false
          })
      })
      }
      
   };
   return (
    <div className="col-xl-12 col-lg-12">
    <div className="card">
       <div className="card-header">
          <h4 className="card-title">Create Insititute</h4>
       </div>
       <div className="card-body">
          <div className="basic-form" style={{color:`black`}}>
             <form  onSubmit={(e) => e.preventDefault(submitHandler)}>
                <div className="form-row">
                   <div className="form-group col-md-6">
                      <label>Institute Name</label>
                      <input
                         type="text"
                         className="form-control"
                         placeholder="Institute Name"
                         onChange={(e)=> setInstituteName(e.target.value)}
                      />
                   </div>
                   <div className="form-group col-md-6">
                      <label>Username</label>
                      <input
                         type="text"
                         className="form-control"
                         placeholder="username"
                         onChange={(e)=> setUsername(e.target.value)}
                      />
                   </div>
                   <div className="form-group col-md-6">
                      <label>Description</label>
                      <input type="text" placeholder="Description" className="form-control" onChange={(e)=> setDescription(e.target.value)}/>
                   </div>
                   <div className="form-group col-md-6">
                      <label>Email</label>
                      <input
                         type="email"
                         className="form-control"
                         placeholder="Email"
                         onChange={(e)=> setEmail(e.target.value)}
                      />
                   </div>
                   <div className="form-group col-md-6">
                      <label>Password</label>
                      <input
                         type="password"
                         className="form-control"
                         placeholder="Password"
                         onChange={(e)=> setPassword(e.target.value)}
                      />
                   </div>
                   <div className="form-group col-md-6">
                      <label>Confirm Password</label>
                      <input
                         type="password"
                         className="form-control"
                         placeholder="Password"
                         onChange={(e)=> setCPassword(e.target.value)}
                      />
                   </div>
                   <div className="form-group col-md-6">
                      <label>Address</label>
                      <input type="text" className="form-control" onChange={(e)=> setAddress(e.target.value)} />
                      
                   </div>
                   <div className="form-group col-md-6">
                      <label>City</label>
                      <input type="text" className="form-control" onChange={(e)=> setCity(e.target.value)}/>
                   </div>
                
                   <div className="form-group col-md-6">
                      <label>State</label>
                      <input type="text" className="form-control" onChange={(e)=> setState(e.target.value)}/>
                      {/* <select
                         id="inputState"
                         className="form-control"
                      >
                         <option selected>Choose...</option>
                         <option>Option 1</option>
                         <option>Option 2</option>
                         <option>Option 3</option>
                      </select> */}
                   </div>
                   <div className="form-group col-md-6">
                      <label>Country</label>
                      <input type="text" className="form-control" onChange={(e)=> setCountry(e.target.value)}/>
                   </div>
                   <div className="form-group col-md-6">
                      <label>Contact</label>
                      <input type="number" className="form-control" onChange={(e)=> setContact(e.target.value)}/>
                   </div>
                   <div className="form-group col-md-6">
                      <label>Credits</label>
                      <input type="number" className="form-control" onChange={(e)=> setCredits(e.target.value)}/>
                   </div>
                   {/* <div className="input-group form-group">
                              <div className="custom-file">
                                 <input
                                    type="file"
                                    className="custom-file-input form-control"
                                    onChange={(e)=> setAvatar(e.target.files[0])}
                                 />
                                 <label className="custom-file-label">
                                    Choose file
                                 </label>
                              </div>
                           </div> */}
                </div>
                <div className= "d-flex justify-content-center">
                <button type="submit" className="btn btn-primary" onClick={(e) => submitHandler(e)}>
                   Submit
                </button>
                </div>
             </form>
          </div>
       </div>
    </div>
 </div>
   );
};

export default InstituteRegisteration;
